import {useEffect, useRef} from 'react';
import {useOverlayTriggerState} from '@react-stately/overlays';
import {
    useOverlay,
    ariaHideOutside,
    useOverlayFocusContain,
} from '@react-aria/overlays';

/**
 * Alternative to `useModal` that does not use `useModalOverlay`.
 *
 * Provides modal behavior (focus trapping, outside interaction blocking, dismiss handling)
 * without preventing scroll. This is useful on mobile Safari where `usePreventScroll` (used in implementation of useModalOverlay)
 * causes the virtual keyboard to cover focused inputs.
 */
export const useModalWithoutPreventScroll = (isOpen: boolean) => {
    const ref = useRef<HTMLDivElement>(null);
    const state = useOverlayTriggerState({isOpen});
    const {overlayProps} = useOverlay(
        {isOpen: state.isOpen, onClose: state.close},
        ref,
    );
    useOverlayFocusContain();
    useEffect(() => {
        if (state.isOpen && ref.current) {
            return ariaHideOutside([ref.current], {shouldUseInert: true});
        }
    }, [state.isOpen]);
    return {ref, modalProps: overlayProps};
};
